
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
} from '@/api/toBApi';

@Component({
	name: 'MEMBERTABLE',
	components: {
	}
})
export default class MEMBERTABLE extends Vue {
	@Prop({ default: [] }) list!: any;

	private pageNo = 1;
	private pageSize = 5;
	private total = 0;
	private members = [];

	get tableData() {
		const { pageNo, pageSize, members } = this;

		let start = (pageNo - 1) * pageSize;
		let end = start + pageSize;
		// if (members.length <= start && pageNo > 1){
		// 	this.pageNo--;
		// 	start = (this.pageNo-1) * pageSize;
		// 	end = start + pageSize;
		// }

		this.total = members.length;
		return members.slice(start, end);
	}

	@Watch('list')
	private listChange() {
		this.members = this.list;
	}
	private mounted() {
		this.members = this.list;
	}

	private changePage(e) {
		this.pageNo = e;
	}
	private handleDeleteMember(record) {
		this.members = this.members.filter(item => {
			return item.Id !== record.Id;
		})

		if (this.members.length <= (this.pageNo - 1) * this.pageSize && this.pageNo > 1) {
			this.pageNo--;
		}

		this.$emit('change', this.members)
	}

}
